export default __webpack_public_path__ + "static/soehne-web-buch-3e6e2906463986be0f70f8d11be3bb70.eot";